module.exports = __webpack_public_path__ + "static/media/mazaZoleWon_2500_5000.72b65bd4.png";